
import Navbar from './header';
import HeroSlider from './components/HeroSlider';
import Footer from './footer';
import DoctorList from './components/doctorList';

export default function Home() {




  return (
    <>

      <Navbar  showlogo={false} />


      <HeroSlider />

      <div class="line-vr-section"></div>

      <DoctorList />

      <div class="line-vr-section"></div>



      <Footer />

    </>
  );
}
